import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import { File } from '../../file/File'
import type { ChatMessageFormatEnum } from '../Chat'
import { ChatSender } from '../ChatSender'

@InputType()
export class BaseChatMessageArgs extends ActionArgs {
  @Field(() => String)
  content: string

  @Field(() => String)
  format: ChatMessageFormatEnum

  @Field(() => Boolean)
  isPublic: boolean

  @Field(() => String)
  chatId?: string

  @Field(() => String)
  extenalId?: string

  @Field(() => ChatSender)
  sender?: ChatSender

  @Field(() => String)
  subject?: string

  @Field(() => String)
  status?: string

  @Field(() => [File], { nullable: true })
  attachments?: File[]
}
